import { render, staticRenderFns } from "./advanceSettings.vue?vue&type=template&id=a7678142&scoped=true"
import script from "./advanceSettings.vue?vue&type=script&lang=js"
export * from "./advanceSettings.vue?vue&type=script&lang=js"
import style0 from "./advanceSettings.vue?vue&type=style&index=0&id=a7678142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7678142",
  null
  
)

export default component.exports